export const filesMixin = {
    methods: {
        getMediaFileNameFromURL(url) {
            const baseUrl = url.split("?")[0];
            const filename = baseUrl.split("/").pop();
            return filename;
        }
    },
};